// extracted by mini-css-extract-plugin
module.exports = {"open-text-input":"styles-module__open-text-input___1TNqQ"};